export const OrderStatus = Object.freeze({
  New: "1bf61851-347c-4d0d-a62e-d488dce9c0da",
  Reservation: "2bf61851-347c-4d0d-a62e-d488dce9c0da",
  ReservationConfirm: "0bf62851-347c-4d0d-a62e-d488dce9c0da",
  Wait: "3bf61851-347c-4d0d-a62e-d488dce9c0da",
  Sended: "5bf61851-347c-4d0d-a62e-d488dce9c0da",
  Closed: "6bf61851-347c-4d0d-a62e-d488dce9c0da",
  Cancel: "8bf61851-347c-4d0d-a62e-d488dce9c0da",
  Expired: "1bf21861-387c-3d0d-a62e-d488dce9c0da",
  TailoringConfirmed: "124f7ab2-9af9-45af-9e66-3fefc9fca101",
  TailoringInProduction: "8d48c2f5-767e-45f8-a0b7-675f6cb8efb0",
  TailoringReadyForShipment: "ec6d3806-1d41-4de1-a4ff-2fd9d93f0eef",
  Refund: "7bf61851-347c-4d0d-a62e-d488dce9c0da",
  Merge: "08f66932-0655-4f13-af06-3df137f75cf1",
  Resort: "9bf61851-347c-4d0d-a62e-d488dce9c0da",
});
